/*
 * @Author: Qzx
 * @Date: 2020-04-07 11:34:28
 * @Description: 集团JSSDK 外链引入
 * @LastEditors: Qzx
 * @LastEditTime: 2020-04-07 12:05:51
 */
(function () {
  let _env = ''
  if (/env=test/.test(window.location.href)) _env = 'test-'
  const script = document.createElement('script')
  script.src = '//' + _env + 'ucres.100tal.com/libs/jssdk/passport@1.06.04/passport.js?t=20200407'
  document.body.appendChild(script)
  script.onload = function () {
    window.TAL_UC.rankConfig({
      'client-id': '111202' // client-id由平台发放权限码，接入之前向平台申请
    })
  }
})()
